interface GridProps {
  size?: number;
  columns?: number;
  rowgap?: string;
  columngap?: string;
}

import styled, { css } from 'styled-components';

export const Container = styled.div`
  @media print {
    display: none !important;

    @page {
      size: A4 portrait;
    }
  }

  header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    padding: 10px;
    z-index: 99;
    position: relative;

    h1 {
      color: #00a859;
      font-weight: 600;
    }

    nav {
      button {
        border: 1px solid #00a859;
        background-color: transparent;
        border-radius: 4px;
        color: #171412;
        font-weight: 600;
        font-family: 'Poppins';
        height: 40px;
        padding-left: 8px;
        padding-right: 8px;
      }

      > button {
        margin-left: 10px;
      }

      & :hover {
        cursor: pointer;
        color: #00a859;
      }
    }
  } /* END HEADER */
`;

export const ContentWrapper = styled.div`
  padding: 48px;
`;

export const ChecklistWrapper = styled.div`
  border-radius: 8px;
`;

export const GridContainer = styled.section<GridProps>`
  display: grid;
  ${props =>
    props.size
      ? css`
          grid-template-columns: repeat(${props.columns}, ${props.size}px);
        `
      : css`
          grid-template-columns: repeat(4, 200px);
        `}
  ${props =>
    props.columngap
      ? css`
          column-gap: ${props.columngap};
        `
      : css`
          column-gap: unset;
        `}

  ${props =>
    props.rowgap
      ? css`
          row-gap: ${props.rowgap};
        `
      : css`
          row-gap: unset;
        `}

  margin: 2rem auto;
  align-items: center;
  justify-content: center;
  justify-items: center;
  left: 0;
  right: 0;
`;

export const SectionWrapper = styled.div`
  margin-top: 1rem;
  padding: 16px 0;
`;

export const SectionTitle = styled.h3`
  text-align: center;
  color: #00a859;
  padding: 0;
  margin: 0;
`;

export const SectionSubTitle = styled.h5`
  font-weight: 400;
  text-align: center;
`;
